module.exports = __webpack_public_path__ + "static/media/ftc-min.38b2eeac.png";